<script>
import PixelBase from "@/components/tools/PixelBase.vue";
export default {
  extends: PixelBase,
  data() {
    return {
      title: "Google Ads",
      pixelType: "google_ads"
    };
  }
};
</script>
